import { bool, number, object, string } from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components/macro";

import ExtendedFieldPopover from "./ExtendedFieldPopover";
import { cellContainerStyles, editableCellStyles } from "./cellContainerStyles";

// const AddressCell = memo(addressCell);
// export default AddressCell;

AddressCell.propTypes = {
  columnID: number,
  entityID: number,
  value: string,
  rawValue: string,
  extendedFieldData: object,
  canEdit: bool,
};

export default function AddressCell({
  columnID,
  entityID,
  value,
  rawValue,
  extendedFieldData,
  // saveCellValue,
  canEdit,
}) {
  const [showPopover, setShowPopover] = useState(false);
  const buttonRef = useRef();
  const [lineOne, lineTwo] = value.split("||");

  const getLineTwo = () => {
    if (String(lineTwo)?.trim() === ",") {
      // don't display a lone comma
      return "";
    }

    return lineTwo;
  };

  const fullValueForHover = value.replace("||", ", ");

  let initialValue;
  if (typeof rawValue !== "undefined") {
    try {
      initialValue = JSON.parse(rawValue);
    } catch (e) {
      console.error(e);
    }
  } else {
    initialValue = {
      addr1: "",
      city: "",
      state: "",
      zip: "",
      country: "US",
    };
  }

  const isSacramentField =
    extendedFieldData?.fieldTypeInstanceStructureGroupingID === 1;
  const isEditable = canEdit && !isSacramentField;

  const handleCellClick = () => {
    if (!isEditable) return;
    setShowPopover((prev) => !prev);
  };

  const handleKeyPress = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    handleCellClick();
  };

  const extendedFieldPopoverId = `${
    extendedFieldData?.title ?? "address"
  }-${entityID}-${columnID}`
    .replaceAll(" ", "-")
    .toLowerCase();

  return (
    <>
      <ExtendedFieldPopover
        buttonRef={buttonRef}
        showPopover={showPopover}
        setShowPopover={setShowPopover}
        field={extendedFieldData}
        initialValue={initialValue}
        cellData={{ columnID, entityID }}
      />
      <Container
        ref={buttonRef}
        title={fullValueForHover}
        onClick={handleCellClick}
        onKeyPress={handleKeyPress}
        canEdit={isEditable}
        role="combobox"
        tabIndex={0}
        aria-expanded={showPopover}
        aria-haspopup="dialog"
        aria-controls={extendedFieldPopoverId}
      >
        <Line>{lineOne || <>&nbsp;</>}</Line>
        <Line>{getLineTwo()}</Line>
      </Container>
    </>
  );
}

const Container = styled.address`
  ${cellContainerStyles};
  ${(p) => (p.canEdit ? editableCellStyles : null)}
  cursor: ${(p) => (p.canEdit ? "pointer" : "default")};
  padding: 1px 4px;
  font-size: 11px;
  font-style: normal;
`;

const Line = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  line-height: 1.2;
`;
